[
  {
    "email": "user@amaalmomineen.com",
    "password": "password123",
    "phone": "9036087945",
    "token": "dummy-token-user",
    "name": "Demo User",
    "role": "user"
  },
  {
    "email": "admin@amaalmomineen.com",
    "password": "admin123",
    "phone": "9108078692",
    "token": "dummy-token-admin",
    "name": "Demo Admin",
    "role": "admin"
  }
]
